import { AxiosPromise } from 'axios';
import { api } from './api';

export class ContentAPI {
  static getContent(id: string | number): AxiosPromise {
    return api.get(`/contents/${id}.jsonld`);
  }

  static getCategoryContents(id: string | number, page: number): AxiosPromise {
    return api.get(`/content-categories/${id}/contents.jsonld`, {
      params: {
        status: 'published',
        itemsPerPage: 6,
        page,
      },
    });
  }
}
